import { render, staticRenderFns } from "./CardDocs.vue?vue&type=template&id=ef4744e8&scoped=true&"
import script from "./CardDocs.vue?vue&type=script&lang=js&"
export * from "./CardDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4744e8",
  null
  
)

export default component.exports